import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "navigation-panel" };
import { ref, markRaw } from 'vue';
import { useRoute } from 'vue-router';
import HomeIcon from '@/icons/HomeIcon.vue';
import CalendarIcon from '@/icons/CalendarIcon.vue';
import UsersIcon from '@/icons/UsersIcon.vue';
import SuitecaseIcon from '@/icons/SuitecaseIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavigationPanel',
    setup: function (__props) {
        var route = useRoute();
        var navigation = ref([
            {
                name: 'Главная',
                icon: markRaw(HomeIcon),
                path: '/',
            },
            {
                name: 'Мероприятия',
                icon: markRaw(CalendarIcon),
                path: '/events',
            },
            {
                name: 'Резиденты',
                icon: markRaw(UsersIcon),
                path: '/residents',
            },
            {
                name: 'Кабинет',
                icon: markRaw(SuitecaseIcon),
                path: '/account',
            }
        ]);
        var isActive = function (path) {
            return route.path === path;
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, function (nav, index) {
                    return (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        to: nav.path,
                        class: _normalizeClass(["navigation-panel__link", { 'active': isActive(nav.path) }])
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", {
                                class: _normalizeClass(["navigation-panel__item", { 'active': isActive(nav.path) }])
                            }, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(nav.icon), {
                                    size: 24,
                                    color: isActive(nav.path) ? '#013766' : '#D8D8D8'
                                }, null, 8, ["color"])),
                                _createElementVNode("p", null, _toDisplayString(nav.name), 1)
                            ], 2)
                        ]; }),
                        _: 2
                    }, 1032, ["to", "class"]));
                }), 128))
            ]));
        };
    }
});
